import { Theme } from '@lifeomic/chroma-react/styles';
import { lighten } from '@mui/material/styles';

export function getCondensedChartColors(theme: Theme) {
  const isDark = theme.palette.mode === 'dark';
  const textPrimary = theme.palette.text?.primary ?? '#262c32';
  const textSecondary = theme.palette.text?.secondary ?? '#576674';
  const textHint = theme.palette.text?.hint ?? lighten('#576674', 0.3);
  const divider = theme.palette.divider ?? lighten('#dbdbdb', 0.35);
  const paper = theme.palette.background?.paper ?? '#ffffff';

  return {
    title: textPrimary,
    label: isDark ? textSecondary : '#576674',
    labelMuted: isDark ? textHint : lighten('#576674', 0.3),
    labelMutedLight: isDark ? textSecondary : lighten('#576674', 0.15),
    labelMutedMedium: isDark ? textHint : lighten('#576674', 0.2),
    axisStroke: isDark ? divider : lighten('#dbdbdb', 0.35),
    lineStroke: isDark ? divider : '#dbdbdb',
    flyoutFill: isDark ? paper : '#f5f8fa',
    scatterFill: isDark ? paper : '#ffffff',
    defaultDotStroke: isDark ? textHint : '#dbdbdb',
    deltaPositive: '#387f15',
    deltaNegative: '#D2691E',
  };
}
